import { filterWithPaginationStates, useFilterWithPaginationV2 } from 'hooks';
import { DEFAULT_PAGINATION, type FilterWithPaginationStateShape } from 'hooks/useFilterWithPagination';
import type { MeterModelsApiFilter } from 'lib/services';

export type CompatibleModelsFilterShape = Pick<MeterModelsApiFilter, 'search' | 'sort' | 'manufacturerId'> & {
  search?: MeterModelsApiFilter['search'];
  commodity?: MeterModelsApiFilter['commodity'];
};

const STATE_KEY = 'CompatibleModelsFilterState';

export const DEFAULT_FILTER: CompatibleModelsFilterShape = {
  search: undefined,
  commodity: undefined,
  manufacturerId: undefined,
  sort: {
    name: 'asc',
  },
};

const PAGINATION = {
  ...DEFAULT_PAGINATION,
  sort: {
    name: 'asc',
  },
} as const;

const states = filterWithPaginationStates({
  domainKey: STATE_KEY,
  filterDefaultValue: DEFAULT_FILTER,
  paginationDefaultValue: PAGINATION,
});

export type CompatibleModelsFilterWithPaginationShape = FilterWithPaginationStateShape<CompatibleModelsFilterShape>;

export const useCompatibleModelsFilterWithPagination = (): CompatibleModelsFilterWithPaginationShape =>
  useFilterWithPaginationV2(states);
